<script>
import onlineSectionTabs from '../Section-Tabs/onlineSectionTabs.vue'
import speciesOfInterestBaseWrapper from './baseWrapper'
import rowComponentWrapper from './rowComponentWrapper'
import healthyComparisonFilter from '../../components/Healthy-Comparison-Filter/index'
import commonFunctions from '../../mixins/commonFunctions'

export default {
  name: 'SpeciesOfInterestOnlineWrapper',
  components: { rowComponentWrapper, healthyComparisonFilter, onlineSectionTabs },
  extends: speciesOfInterestBaseWrapper,
  mixins: [commonFunctions],
  computed: {
    activeTabDefaultGroupData () {
      if (!this.data) return []
      return this.data[this.activeTab?.key]?.default
    },
    activeTabOtherGroupData () {
      if (!this.data) return []
      return this.data[this.activeTab?.key]?.other
    }
  },
  mounted () {
    this.toggleCollapseAll()
  },
  methods: {
    selectTab (tab) {
      this.selectedCategory = tab
      this.toggleCollapseAll()
      setTimeout(() => {
        this.toggleCollapseAll()
      }, 0)
    },
    toggleDescriptionRow (payload, rowGrouping) {
      const dataGroup =
        rowGrouping === 'default'
          ? this.activeTabDefaultGroupData
          : this.activeTabOtherGroupData
      const rowItem = dataGroup.find(
        (rowItem) => rowItem.labelKey === payload.rowInfo.labelKey
      )
      rowItem.visible = payload.visible
    },
    toggleCollapseAll () {
      this.collapseAll = !this.collapseAll
      this.categories.forEach((category) => {
        const defaultData = this.data[category.key]?.default || []
        defaultData.forEach((rowItem) => {
          rowItem.visible = !this.collapseAll
        })
        const otherData = this.data[category.key]?.other || []
        otherData.forEach((rowItem) => {
          rowItem.visible = !this.collapseAll
        })
      })
    }
  }
}
</script>
<template>
  <div
    class="speciesOfInterest component container"
    :class="{
      rtl: readDirection === 'rtl'
    }"
  >
    <div class="row">
      <div class="col-12">
        <h3>
          {{ i18n.t('details.sections.interest.title') }}
        </h3>
        <p>
          {{ i18n.t('details.sections.interest.description') }}
        </p>
      </div>
      <div
        v-if="showCohortComparison"
        class="col-12 pt-3"
      >
        <healthyComparisonFilter
          :filters="filters"
          @display:comparisonDraw="$emit('display:comparisonDraw')"
        />
      </div>
      <div class="col-12 pt-3">
        <onlineSectionTabs
          :chart-type="'interest'"
          :tabs="tabs"
          @tab-changed="selectTab($event)"
        />
      </div>
      <div class="col-12 row mt-3 health-association-filter">
        <div class="col-4 health-association-filter__label">
          {{
            i18n.t('details.sections.interest.healthAssociationFilter.label')
          }}
        </div>
        <div class="col-5 text-center health-association-filter__options">
          <div class="row">
            <b-form-checkbox
              v-model="healthAssociation.goodHealth"
              class="option"
            >
              {{
                i18n.t(
                  'details.sections.interest.healthAssociationFilter.goodHealth'
                )
              }}
            </b-form-checkbox>
            <b-form-checkbox
              v-model="healthAssociation.poorHealth"
              class="option"
            >
              {{
                i18n.t(
                  'details.sections.interest.healthAssociationFilter.poorHealth'
                )
              }}
            </b-form-checkbox>
            <b-form-checkbox
              v-model="healthAssociation.noHealth"
              class="option"
            >
              {{
                i18n.t(
                  'details.sections.interest.healthAssociationFilter.noKnownAssociation'
                )
              }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="col-3 health-association-filter__expand">
          <a @click="toggleCollapseAll">
            {{
              collapseAll
                ? i18n.t(
                  'details.sections.interest.healthAssociationFilter.expandAll'
                )
                : i18n.t(
                  'details.sections.interest.healthAssociationFilter.collapseAll'
                )
            }}
            <i
              :class="{
                'fa fa-chevron-up': !collapseAll,
                'fa fa-chevron-down': collapseAll
              }"
            />
          </a>
        </div>
      </div>
      <div class="col-12">
        <div class="pt-3">
          <div class="row p-1 genus-heading">
            <div
              :class="containsMultipleSamples ? 'col-6' : 'col-9'"
              class="genus-heading__left"
            >
              {{ i18n.t('details.sections.interest.genusHeader.genus') }}
            </div>
            <div
              :class="containsMultipleSamples ? ['col-6', 'text-center'] : 'col-3'"
              class="genus-heading__right"
            >
              {{
                i18n.t('details.sections.interest.genusHeader.detectionStatus')
              }}
            </div>
          </div>
          <rowComponentWrapper
            v-if="data && data[activeTab.key].default"
            :row-component-data="data[activeTab.key].default"
            :health-association="healthAssociation"
            :category="activeTab.key"
            :contains-multiple-samples="containsMultipleSamples"
            @display:speciesDetails="$emit('display:speciesDetails', $event)"
            @toggleDescriptionRow="toggleDescriptionRow($event, 'default')"
          />
          <rowComponentWrapper
            v-if="data && data[activeTab.key].other"
            :row-component-data="data[activeTab.key].other"
            :health-association="healthAssociation"
            :category="activeTab.key"
            :contains-multiple-samples="containsMultipleSamples"
            @display:speciesDetails="$emit('display:speciesDetails', $event)"
            @toggleDescriptionRow="toggleDescriptionRow($event, 'other')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .speciesOfInterest {
    &.rtl {
      .health-association-filter {
        left: initial;
        right: 16px;
      }
      .custom-control {
        padding-inline: 1.5rem 0;
        &-input {
          left: initial;
          right: 0;
        }
        &-label {
          &:before,
          &:after {
            left: initial;
            right: -1.5rem;
          }
        }
      }
    }
    .genus {
      &-heading {
        background-color: #003765;
        color: white;
        margin: 0 10px;
        font-size: 16px;
        font-weight: 400;
        text-transform: uppercase;
        &__left {
          left: 35px;
        }
        &__right {
          right: 30px;
        }
      }
    }
    .row-component {
      width: 98%;
      padding: 16px;
      border-bottom: 1px solid #e0d3d3;
      .label {
        .label-genus {
          font-size: 18px;
          font-weight: 600;
          font-style: italic;
          color: #003765;
        }
        .label-detection {
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          text-align: end;
        }
        .expandCollapseChevron {
          margin-inline-start: 3rem;
          .detected {
            color: #ff8708;
          }
          .notDetected {
            color: grey;
          }
        }
      }
      .info-header {
        margin-top: 16px;
        color: #7a8495;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
      }
    }
    .health-association-filter {
      left: 16px;
      a {
        color: #ff8708;
        text-decoration: none;
        cursor: pointer;
        &:hover {
          color: #ff8708;
        }
      }
      &__label {
        font-size: 18px;
        font-weight: 500;
        bottom: 2px;
      }
      &__options {
        font-size: 14px;
        color: grey;
        .option {
          margin-inline-end: 14px;
          .custom-control-input:checked ~ .custom-control-label::before {
            background-color: #ff8708;
            border-color: #ff8708;
          }
        }
      }
      &__expand {
        text-align: end;
        font-size: 16px;
        font-weight: bold;
      }
    }
    &-component {
      .component-online {
        background-color: #fbfbfb;
        border-radius: 3px;
        margin-top: 16px;
      }
      .species-name {
        font-size: 20px;
        font-style: italic;
        font-weight: 700;
        line-height: 30px;
        text-decoration: none;
        color: #168ccc;
        cursor: pointer;
      }
      .abundance-level {
        font-size: 20px;
        font-weight: 300;
        line-height: 30px;
      }
      .health-indicator-icon {
        height: 14px;
        width: auto;
        margin-bottom: 1px;
        margin-inline-start: 3rem;
      }
    }
  }
</style>
